import React, { useMemo } from "react";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";

const TopHeaderViewer = (props) => {
  const { setActiveTabMain, activeTabMain, tabs } = props;
  const classes = useStyles();

  const { enable: tabsEnabled, labels = {}, ...tabDefs } = tabs || {};

  const enabledTabs = useMemo(() => {
    return Object.values(tabDefs || {})
      .filter((t) => t && typeof t === "object" && t.enable)
      .map((t) => ({
        key: t.name, 
        label: labels?.[t.name] ?? t.title ?? t.name, 
        config: t,
      }));
  }, [tabDefs, labels]);

  if (!tabsEnabled || enabledTabs.length === 0) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div className={classes.tabsRow}>
        {enabledTabs.map((tab) => {
          const isActive = activeTabMain === tab.key;

          return (
            <div
              key={tab.key}
              className={classes.tab}
              style={{
                borderBottom: isActive
                  ? "1px solid rgba(63, 81, 181, 1)"
                  : "1px solid transparent",
                marginBottom: isActive ? "-1px" : 0,
              }}
              onClick={() => setActiveTabMain(tab.key)}
            >
              <Typography
                className={classes.tabText}
                style={{
                  color: isActive
                    ? "rgba(63, 81, 181, 1)"
                    : "rgba(120, 121, 142, 1)",
                }}
              >
                {tab.label}
              </Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopHeaderViewer;
